<template>
  <img :src="blank" :data-src="src" :class="classes" :style="dimensions" @lazybeforeunveil="imgLoaded" />
</template>

<script>
import { mdImg } from '@/utils'

export default {
  name: 'BaseImage',
  props: {
    img: [Object, String]
  },
  data () {
    return {
      blank: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
      rendered: false,
      loaded: false,
      pw: null
    }
  },
  computed: {
    imgProps () {
      if (!this.img.sizes) return

      // return scaled size
      const s = this.pw > 1400 ? 'original' : this.pw > 800 ? 'lg' : 'md'

      return this.img.sizes[s]
    },
    src () {
      if (!this.rendered) return
      if (this.rendered && !this.imgProps) return mdImg(this.img)

      return this.imgProps.src
    },
    dimensions () {
      // if (!this.imgProps) return
      if (this.loaded || !this.imgProps) return

      const w = this.imgProps.width <= this.pw ? this.imgProps.width : this.pw
      const h = Math.round(w / this.imgProps.ratio)
      if (!h) return

      // temporary sizing, removed when loaded
      return {
        width: `${w}px`,
        height: `${h}px`
      }
    },
    classes () {
      return this.rendered && 'lazyload'
    }
  },
  methods: {
    mdImg,

    imgLoaded () {
      this.$nextTick(() => {
        this.loaded = true
      })
    }
  },
  mounted () {
    const p = this.$el.parentElement
    const gp = p.parentElement
    const ggp = gp.parentElement

    this.pw = Math.max(p.clientWidth, gp.clientWidth, ggp.clientWidth)
    this.rendered = true
  }
}
</script>
